import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component';
import { LinkComponent } from '@components/link/link.component';
import { ApiService, UserInfo } from 'app/services/api.service'

@Component({
  selector: 'app-item-information-rewards',
  standalone: true,
  templateUrl: './item-information-rewards.component.html',
  styleUrls: ['./item-information-rewards.component.scss'],
  imports: [CommonModule, CosentinoSvgComponent, LinkComponent],
})

export class ItemInformationRewardsComponent implements OnInit {
  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() icon!: string;
  @Input() btnName?: string;
  @Input() showButton: boolean = false;
  @Input() backgroundImage!: string;

  @Output() click = new EventEmitter<void>();

  userInfo: UserInfo;

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    this.api.userInfo.subscribe((userInfo) => {
        this.userInfo = userInfo
    });
  }

  getIcon(){
    return this.icon.toString() || 'view-more';
  }

  handleItemClick(option: string, event: Event | null = null) {
    if (event) {
      event.preventDefault();
    }
    //console.log('---- ITEM - ' + option);
    //let item = this.userInfo.mainMenu.items.find((item) => item.code === 'Go to e.Cosentino');
    //if (item?.link) window.open(item.link, '_blank');
  }

  goToEConsentino() {
    let item = this.userInfo.mainMenu.items.find((item) => item.code === 'e-cosentino');
    //if (item?.link) window.open(item.link, '_blank');
  }
}

